import * as Doms from "oc-ui/Doms";

// Global declarations for I18N function
declare global {
  interface Window {
    unhandledrejectionHandlers?: Array<(event: PromiseRejectionEvent) => void>;
  }
}

/**
 * Interface für unhandled rejection events
 */
interface IPromiseRejectionEvent {
  reason: unknown;
}

/**
 * Registriert einen Standard-Errorhandler für nicht abgefangene Fehler,
 * der einen Fehlerdialog anzeigt.
 */
export function registerDialogsErrorHandler(): void {
  let countErrorRecursiveCalls = 0;

  window.onerror = errorHandler;

  window.unhandledrejectionHandlers = window.unhandledrejectionHandlers ?? [];
  const unhandledrejection = (e: PromiseRejectionEvent): void => {
    errorHandler(e.reason as string);
    // handle error here, for example log
  };
  window.unhandledrejectionHandlers.push(unhandledrejection);
  window.addEventListener("unhandledrejection", unhandledrejection);

  function errorHandler(
    message: string | Event,
    javascriptSourceFileUrl?: string,
    lineNumber?: number,
    columnNumber?: number,
    errorObject?: Error,
  ): boolean {
    debugger;
    if ((message + "").indexOf("TextureLoader could not load") == 0) {
      // dieser Fehler soll nur geloggt werden, und das passierte bereits
      return false;
    }
    if (countErrorRecursiveCalls > 0) {
      return false;
    }
    // debugger;
    countErrorRecursiveCalls++;
    console.log(
      message,
      " (in " + javascriptSourceFileUrl + " line " + lineNumber + ")",
      errorObject,
    );

    try {
      const errorDiv = Doms.createElementFromHTML(`
                <div class="error-dialog-container">
                    <div class="error-dialog">
                        ${I18N("ErrorOccuredWithMessage", message)}
                        <div style="display: flex; gap: 1rem;">
                          <button>${I18N("OK")}</button>
                          <button onclick="location.reload()">${I18N("Neu Laden")}</button>
                        </div>
                    </div>
                </div>
            `);
      errorDiv
        .querySelector("button")!
        .addEventListener("click", () => document.body.removeChild(errorDiv));
      document.body.appendChild(errorDiv);
    } catch (e) {
      alert(message as string);
    }

    return false;
  }
}
